<form nz-form nzLayout="vertical" [formGroup]="formGroup()">
  @if (showTitle()) {
    <h4>{{ 'shared.emailNotification.header' | translate }}</h4>
  }

  <div nz-row [nzGutter]="32">
    <div nz-col [nzSpan]="24">
      <nz-form-item>
        <nz-form-label
          nzFor="notificationEmails"
          [nzTooltipTitle]="'shared.emailNotification.tooltip' | translate"
        >
          {{ 'shared.emailNotification.label' | translate }}
        </nz-form-label>
        <nz-form-control
          [nzErrorTip]="'shared.emailNotification.label' | fieldValidationMsg"
        >
          <input
            id="notificationEmails"
            nz-input
            formControlName="notificationEmails"
            [placeholder]="'shared.emailNotification.label' | translate"
          />
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
</form>
